import { api } from "@/services/api"
import { useMutation } from "@tanstack/react-query"
import type { ProductTourStatus } from "@/services/api/cronos/user/info/get"

export default function useUpdateProductTourStatus() {
  return useMutation({
    mutationKey: ["update-product-tour-status"],
    mutationFn: (status: ProductTourStatus) => api.cronos.productTour.update({ status }),
  })
}
